import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Environment  {
    _originalTypeClassName = "zAppDevManager.BO.Environment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Environment.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Server = null;
this.Database = null;
this.User = null;
this.Password = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Server:any;
Database:any;
User:any;
Password:any;
Type:any;

static BuildConnectionString($this: any): any{return "Data Source=" + $this?.Server + ";Initial Catalog=" + $this?.Database + ";Integrated Security=False;User ID=" + $this?.User + ";Password=" + $this?.Password;
}
static HasOldSchema($this: any): any{return Joove.Common.stringContains($this?.Name, "egacy");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}